import { type SxProps, type Theme } from "@mui/material/styles";

import { Box } from "ui/box";
import { mergeSx } from "ui/merge-sx";

import Icons from "assets";

type ChannelIconProps = {
  channel?: string;
  sx?: SxProps<Theme>;
};

const CHANNEL_ICON_SX = {
  width: 16,
  height: 16,
  flexShrink: 0,
  color: "grey.600",
} as const;

export const ChannelIcon = ({ channel, sx }: ChannelIconProps) => {
  const iconSx = mergeSx(CHANNEL_ICON_SX, sx);

  if (channel === "email") {
    return <Box component={Icons.Email} sx={iconSx} aria-hidden />;
  }

  if (channel === "web-page" || channel === "form") {
    return <Box component={Icons.LandingPage} sx={iconSx} aria-hidden />;
  }

  return <Box component={Icons.Other} sx={iconSx} aria-hidden />;
};
